import 'css-chunksrc/client/pages/projectPage/synthesisPage/pdfExport/styles.scss';export default {
  "link": "_link_1q5tg_1",
  "icon": "_icon_1q5tg_23"
};